import classNames from "classnames/bind";
import { useEffect, useRef, useState } from "react";
import { Button, Pagination, SelectBox, SelectBoxItem, Toast } from "../../../../../components";
import { Close, SearchIcon } from "../../../../../components/Icons/Icons";
import useFetchData from "../../../../../hooks/useFetchData";
import axiosClient from "../../../../../services/axiosClient";
import ModalMoreInfo from "../../../Camera/ModalMoreDetail";
import ModalSetting from "../../../Camera/ModalSetting";
import styles from "./ModalListCamera.module.css";
import TableListCamera from "./TableListCamera";
import { registeredCamServiceAPI } from "../../../../../services/api/registeredCamServiceAPI";
import { getTimeFormArray } from "../../../../../utils";
import ModalAddCamera from "../ModalAddCamera";

const cx = classNames.bind(styles);

function ModalListCamera({ getHideModal, nameService }) {
    const [code, setCode] = useState()
    const [isSetting, setIsSetting] = useState(false)
    const [isRefresh, setIsRefresh] = useState(false)
    const [input, setInput] = useState()
    const [listCamera, setListCamera] = useState();
    const [status, setStatus] = useState()
    const [cameraInfo, setCameraInfo] = useState([{ STATUS: '' }]);
    const refModal = useRef(null)
    const [dataMore, setDataMore] = useState({ data: [], type: '' })
    const [showModalMore, setShowModalMore] = useState(false)
    const [totalPage, setTotalPage] = useState(1);
    const [showModalAddCamera, setShowModalAddCamera] = useState(false);
    const [fillter, setFillter] = useState({
        cameraName: '',
        status: 1,
        timeStart: null,
        timeEnd: null,
        page: 1,
        size: 10
    })
    const handleShowModalAddCamera = () => {
        setShowModalAddCamera(!showModalAddCamera)
    }


    useEffect(() => {
        const handleCloseOnClickOutSide = (e) => {
            if (e.target === refModal.current) {
                getHideModal()
            }
        }
        document.addEventListener('click', handleCloseOnClickOutSide)
        return () => { document.removeEventListener('click', handleCloseOnClickOutSide) }
    }, [getHideModal])

    const handleCloseSetting = () => {
        setIsSetting(!isSetting)
    }

    useEffect(() => {
        if (code) {
            const getInfoCamera = async () => {
                const res = await axiosClient.get(`cameraManagement/get-camera-info-by-code/?camera_code=${code}`)
                setCameraInfo(res)
            }
            getInfoCamera()
        }
    }, [code])

    const getCodeCamera = (code) => {
        setCode(code)
        setIsSetting(!isSetting)
    }

    const handleSearchText = (data) => {
        setFillter(prev => ({ ...prev, cameraName: data, page: 1 }))
    }

    const handleChangeStatus = (data) => {
        setFillter(prev => ({ ...prev, status: data, page: 1 }))
    }

    const getDataShowMore = (data, type) => {
        setShowModalMore(!showModalMore)
        setDataMore({ data: data, type: type })
    }

    useEffect(() => {
        const getListRegistered = async () => {
            try {
                const res = await registeredCamServiceAPI.get();
                const listCameras = res?.data?.content?.map((item, index) => {
                    return {
                        stt: index + 1,
                        cameraName: item?.cameraCode,
                        timeStartApply: getTimeFormArray(item?.timeApplication),
                        timeEndApply: getTimeFormArray(item?.timeUnapplication),
                        timeStart: item?.timeStart ? getTimeFormArray(item?.timeStart) : '',
                        timeEnd: item?.timeEnd ? getTimeFormArray(item?.timeEnd) : '',
                        status: item?.status
                    }
                })
                setTotalPage(Math.ceil(res.data.totalElements / 10))
                setListCamera(listCameras)
            } catch (error) {
                Toast.open("Lấy danh sách camera không thành công", "danger")
            }
        }
        getListRegistered()
    }, [])

    const handleNextPage = () => {

    }

    const handlePrevPage = () => {

    }

    const handleChosePage = (value) => {

    }
    return (
        <div className={cx('container')} ref={refModal}>
            <div className={cx('content')}>
                <div className={cx('header')}>
                    <h1 className={cx('title')}>
                        Camera áp dụng “<span className={cx('service-name')}>{nameService}</span>”
                    </h1>
                    <span className={cx('close-btn')} onClick={getHideModal}><Close /></span>
                </div>
                <div className={cx('body')}>
                    <div className={cx('filter')}>
                        <div className={cx("search")}>
                            <SearchIcon />
                            <input
                                value={input}
                                onChange={e => handleSearchText(e.target.value)}
                                className={cx("search-input")}
                                placeholder="Tên camera"
                            />
                        </div>
                        <div className={cx('select-box')}>
                            <SelectBox title={'Trạng thái'} type='small' onChange={handleChangeStatus}>
                                <SelectBoxItem
                                    label={'Hoạt động'}
                                    value={'On'}
                                />
                                <SelectBoxItem
                                    label={'Không họat động'}
                                    value={'Off'}
                                />
                            </SelectBox>
                        </div>
                        <div className={cx('select-box')}>
                            <SelectBox title={'Trạng thái'} type='small' onChange={handleChangeStatus}>
                                <SelectBoxItem
                                    label={'Hoạt động'}
                                    value={'On'}
                                />
                                <SelectBoxItem
                                    label={'Không họat động'}
                                    value={'Off'}
                                />
                            </SelectBox>
                        </div>
                        <div className={cx('select-box')}>
                            <SelectBox title={'Trạng thái'} type='small' onChange={handleChangeStatus}>
                                <SelectBoxItem
                                    label={'Hoạt động'}
                                    value={'On'}
                                />
                                <SelectBoxItem
                                    label={'Không họat động'}
                                    value={'Off'}
                                />
                            </SelectBox>
                        </div>
                    </div >
                    <div className={cx('table-container')}>
                        <TableListCamera handleSetting={data => getCodeCamera(data)} dataCamera={listCamera} showModalMore={(data, type) => getDataShowMore(data, type)} />
                    </div>
                    <div className={cx("pagination")}>
                        <Pagination
                            onClick={handleChosePage}
                            onNext={handleNextPage}
                            onPrevious={handlePrevPage}
                            pages={totalPage}
                            currentPage={fillter.page}
                        />
                    </div>
                </div >
                <div className={cx('button')}>
                    <Button title={'Thêm camera'} onClick={handleShowModalAddCamera} className={cx('btn')} />
                </div>
            </div >
            {isSetting && <ModalSetting
                onclose={handleCloseSetting}
                setIsRefresh={setIsRefresh}
                isRefresh={isRefresh}
                camera={cameraInfo && cameraInfo}
                show={isSetting} />}
            {showModalMore && <ModalMoreInfo showModal={getDataShowMore} data={dataMore} />}
            {showModalAddCamera && <ModalAddCamera onClose={handleShowModalAddCamera} isShow={showModalAddCamera}/>}
        </div >
    )
}
export default ModalListCamera;